import clsx from 'clsx';
import { SellerShippingAddress } from '@/types/item';
import { useTranslation } from 'react-i18next';
import { TimelineShippingLabelAction } from '@/external/timeline/interfaces/timeline';
import PopupActionView from '../popup-action';
import { Icon } from '@/external/timeline/fake';
import styles from './address-card.module.scss';

interface AddressProps {
  address?: SellerShippingAddress;
  action?: TimelineShippingLabelAction;
}

const CLASSNAME = 'shippingAddress';
const LANG_PREFIX = 'MY_ACCOUNT.ORDERS_SALES.POPUP.GET_SHIPPING_LABEL.';

const AddressCard = ({ address, action }: AddressProps) => {
  const { t } = useTranslation();

  if (!address) {
    return null;
  }

  const isGetShippingLabel = !!action && action.type === 'getShippingLabel';

  const name = address ? `${address.firstName} ${address.lastName}` : t(`${LANG_PREFIX}YOUR_ADDRESS.ADD_NEW`);

  const fullAddress = address
    ? `${address.address1}, ${address.address2 && `${address.address2},`} ${address.zip} ${address.city}, ${
        address.country
      }`
    : '';

  return (
    <div className={clsx(styles[CLASSNAME], { [styles[`${CLASSNAME}_hideTopBorderRadius`]]: !isGetShippingLabel })}>
      {!isGetShippingLabel && <div className={styles[`${CLASSNAME}_borderTop`]} />}

      <div className={styles[`${CLASSNAME}_header`]}>
        <p>{t(`${LANG_PREFIX}YOUR_ADDRESS`)}</p>

        <button className={styles[`${CLASSNAME}_actionIcon`]}>
          <Icon
            name="edit-16"
            className={styles[`${CLASSNAME}_icon`]}
          />
          <p>{t(`HEADER.SEARCH.MODAL.EDIT_BUTTON`)}</p>
        </button>
      </div>

      <div className={styles[`${CLASSNAME}_content`]}>
        <p>{name}</p>
        <p>{fullAddress}</p>
      </div>

      {isGetShippingLabel && (
        <PopupActionView
          dataCy={`address-card-btn-${action.type}`}
          className={clsx('vc-btn--primary', styles[`${CLASSNAME}_actionButton`])}
        >
          {action.title}
        </PopupActionView>
      )}
    </div>
  );
};

export default AddressCard;
